import React from 'react'
import SignUp from '../components/auth/js/SignUp'
const SignUpPage = () => {
  return (
    <SignUp/>
  )
}

export default SignUpPage